// client/src/pages/business/Home.js
import React, { useEffect } from 'react'; // ✅ Import useEffect
import { useNavigate } from 'react-router-dom'; // ✅ Import useNavigate
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext'; // ✅ Import useAuth
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';

const Home = () => {
  const { t } = useTranslation('business');
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // Mobile redirect removed — visitors should be able to browse without forced login

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="pt-16 lg:pt-0">
        <main className="flex-grow container mx-auto px-4 py-16">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
              WholesaleHub
            </h1>
            <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
              {t('home.subtitle')}
            </p>
            <div className="mt-10 flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <a
                href="/wholesalers"
                className="w-full sm:w-auto bg-blue-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors duration-300"
              >
                {t('home.exploreWholesalers')}
              </a>
              <a
                href="/register"
                className="w-full sm:w-auto bg-white text-blue-600 border-2 border-blue-600 px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-50 transition-colors duration-300"
              >
                {t('home.registerBusiness')}
              </a>
            </div>
            <div className="mt-6">
              <a
                href="/pricing"
                className="text-purple-600 hover:text-purple-700 font-medium text-sm underline-offset-4 hover:underline"
              >
                {t('home.wholesalerCta', 'Are you a wholesaler? See pricing →')}
              </a>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Home;